module.exports = __webpack_public_path__ + "img/triangle.23e946a0.svg";